/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="16.5"
        height="10.35"
        viewBox="0 0 16.5 10.35"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M13.09.47l.07.08,4,4.54a.75.75,0,0,1,.06.9l-.07.09-4,4.33A.74.74,0,0,1,12,9.5l.07-.09L14.9,6.33H1.56a.73.73,0,0,1-.1-1.46H15L12.06,1.51a.73.73,0,0,1,0-1l.08-.07A.73.73,0,0,1,13.09.47Z"
          transform="translate(-0.82 -0.29)"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'ArrowRightIcon';

export default Icon;
